import { ContentFlexComponent, ContentProps, EditorialProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from "bernie-view";
import { Action } from "components/utility/analytics/FlexAnalyticsUtils";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { EditorialFlexModule } from "typings/microserviceModels/content-flex-module";

import { UitkCardAloha, UitkCardContent, UitkCardLink, UitkCardMedia } from "uitk-react-cards";
import { LazyLoadedImage } from "src/components/utility/LazyLoadedImage/LazyLoadedImage";

import { UitkFigure } from "uitk-react-images";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";

export class NativeTileShowcaseEditorial extends EditorialBase {
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    if (!this.editorial.items[0].media || this.editorial.items[0].media.length === 0) {
      return null;
    }

    const [{ media }] = this.editorial.items;
    const [desktopMedia, mobileMedia] = media;

    const desktopMediaURL = desktopMedia ? desktopMedia.mediaUrl : "";
    const mobileMediaURL = mobileMedia ? mobileMedia.mediaUrl : "";

    return (
      <Viewport>
        <ViewSmall>
          <EditorialLayout
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
            imageURL={mobileMediaURL}
          />
        </ViewSmall>
        <ViewMedium>
          <EditorialLayout
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
            imageURL={desktopMediaURL}
          />
        </ViewMedium>
        <ViewLarge>
          <EditorialLayout
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
            imageURL={desktopMediaURL}
          />
        </ViewLarge>
      </Viewport>
    );
  }
}

const EditorialLayout = (props: EditorialProps) => {
  const model: EditorialFlexModule = props.flexComponent.model as EditorialFlexModule;
  if (!model.items[0].media || model.items[0].media.length === 0) {
    return null;
  }
  const moduleName = props.flexComponent.name;
  const cardLabel = model.items[0].title ? model.items[0].title : model.title;
  const cardBody = model.items[0].text ? model.items[0].text : "";

  const cardName = cardLabel && cardLabel.replace(" ", "_");
  const rfrr = `${moduleName}.${cardName}.${Action.CLICK}`;

  const dynamicClickUrl = model.items[0].media[0].clickUrl;

  const url = dynamicClickUrl && dynamicClickUrl.length > 0 ? dynamicClickUrl : model.cardLinkUrl;
  const cardLink = `${url}/?rfrr=${rfrr}`;

  const editorialViewClass = "ntsFlex";
  const uitkClassNames = "all-t-margin-three m-b-margin-three l-b-margin-three xl-b-margin-three";

  const media = model.items[0].media || [
    {
      mediaAlt: "",
    },
  ];
  const { mediaAlt = "" } = media[0];

  /**
   * This is a temporary work around due to limitations of the editorial model that will be addressed in the future.
   * Parsing data from contributed HTML content should not be considered an accepted approach to be repeated elsewhere
   */

  const [, title] = /<span [^>]+>(.*?)<\/span>/g.exec(cardBody) || [];

  return (
    <div
      id={props.flexComponent.id}
      data-fm={props.flexComponent.fmId}
      data-fm-title-id={props.flexComponent.fmTitleId}
      className={`uitk-cell uitk-type-center Editorial all-cell-1-1 ${uitkClassNames}`}
      role="button"
    >
      <UitkCardAloha className={editorialViewClass}>
        <UitkCardMedia className={editorialViewClass}>
          <UitkFigure>
            {props.imageURL}
            <LazyLoadedImage src={props.imageURL} alt={mediaAlt} />
            <UitkScrim type={UitkScrimType.BOTTOM}>
              <div className="uitk-type-left nts-scrim-text" dangerouslySetInnerHTML={{ __html: cardBody }} />
            </UitkScrim>
          </UitkFigure>
        </UitkCardMedia>
        <UitkCardContent>
          <UitkCardLink>
            <a href={cardLink} data-testid="editorial-with-link-anchor">
              {title || model.title || moduleName}
            </a>
          </UitkCardLink>
        </UitkCardContent>
      </UitkCardAloha>
    </div>
  );
};

export default NativeTileShowcaseEditorial;
